
import { ref, onMounted, onUnmounted, watch, defineComponent } from 'vue'
import { MenuOutlined } from '@ant-design/icons-vue'
import { getTreeList } from '../api/api'
import router from '@/router'
// import { Vue } from 'vue-class-component'

export default defineComponent({
  name: 'Header',
  components: {
    MenuOutlined
  },
  setup () {
    const header = ref()
    const logoUrl = ref(`${process.env.BASE_URL}logo.png`)
    const navIndex = ref<number[]>([0]) // 头部nav
    const currentSub = ref(0)
    // 左侧菜单导航
    const leftMenu = ref<any>([])
    // 右侧菜单导航
    const rightMenu = ref<any>([])
    const leftIndex = ref(0)
    const subMenuShow = ref(false) // 子菜单显示
    const subMenuRef = ref()
    const screenWidth = ref(0)
    const isPhone = ref(false)

    const scrollHeight = ref(0)
    const navList = ref<any>([]) // 导航数据
    const treeList = ref<any>([]) // 树形结构数据
    const navId = ref('') // 当前选中nav的菜单id
    onMounted(async () => {
      window.onresize = () => {
        return (() => {
          screenWidth.value =
            document.documentElement.clientWidth ||
            document.body.clientWidth ||
            window.innerWidth
        })()
      }
      window.onscroll = () => {
        return (() => {
          scrollHeight.value = window.scrollY
        })()
      }

      isPhone.value =
        document.documentElement.clientWidth > 0 &&
        document.documentElement.clientWidth < 768

      getTreeList().then((res: any) => {
        console.log(res,'导航数据')
        navList.value = res
        treeList.value = res
      })
    })
    onUnmounted(() => {
      window.onresize = null
      window.onscroll = null
    })
    watch(
      () => screenWidth.value,
      (newValue, oldValue) => {
        if (newValue < 768) {
          isPhone.value = true
        } else {
          isPhone.value = false
        }
      }
    )
    watch(
      () => scrollHeight.value,
      (newValue, oldValue) => {
        if (newValue < 10) {
          header.value.style.backgroundColor = 'transparent'
          logoUrl.value = `${process.env.BASE_URL}logo.png`
        } else {
          // header.value.style.backgroundColor = '#162b5b'
          header.value.style.backgroundColor = 'rgb(14,14,14)'
          logoUrl.value = `${process.env.BASE_URL}logo@col.png`
        }
      }
    )
    // 鼠标移入Nav
    const mouseOver = (index: number) => {
      if (index === 0 || index === 1) {
        if (navIndex.value[0] !== index + 1) {
          navIndex.value = [Number(index) + 1 > 6 ? 5 : Number(index) + 1]
          leftIndex.value = 0
        }
        if (isPhone.value) return
        header.value.style.backgroundColor = 'rgb(14,14,14)'
        header.value.style.borderBottom = '1px solid #666'
        logoUrl.value = `${process.env.BASE_URL}logo@col.png`

        navId.value = navList.value[navIndex.value[0] - 1].id
        treeList.value.forEach((item: any) => {
          if (item.id === navId.value) {
            subMenuShow.value = true
            leftMenu.value = item.childList
            if (item.childList.length > 0) {
              subMenuShow.value = true
              rightMenu.value = item.childList[leftIndex.value].activities
            } else {
              subMenuShow.value = false
            }
          }
        })
      }
    }
    // 鼠标移出Nav
    const mouseLeave = (index: number) => {
      if (isPhone.value) return
      if (scrollHeight.value < 100) {
        header.value.style.backgroundColor = 'transparent'
        logoUrl.value = `${process.env.BASE_URL}logo.png`
      }
      header.value.style.borderBottom = '0'
      subMenuShow.value = false
    }
    // 鼠标移入子菜单
    const mouseSubOver = (index: number) => {
      leftIndex.value = index
      // if (leftMenu.value[leftIndex.value].activities.length > 0) {
      //   rightMenu.value = leftMenu.value[leftIndex.value].activities
      // }
    }
    const toArticle = (id: number) => {
      router.push({
        path: '/article',
        query: { code: treeList.value[navIndex.value[0] - 1].id, id: id }
      })
    }
    return {
      header,
      navIndex,
      currentSub,
      leftMenu,
      rightMenu,
      subMenuShow,
      subMenuRef,
      mouseOver,
      mouseLeave,
      mouseSubOver,
      isPhone,
      MenuOutlined,
      leftIndex,
      logoUrl,
      navList,
      treeList,
      toArticle
    }
  }
})
